module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-6-283788d690e41c009578a5ee776ab34e.png";